import { INewbuildingBuilderSchema } from '../../../repositories/newbuilding-card/entities/builder/NewbuildingBuilderSchema';
import { pick } from 'ramda';
import { TExtra, IProduct } from '../../../types/analytics/products';

export function getProductsData(id: number, builder?: INewbuildingBuilderSchema | null, extra?: TExtra): IProduct {
  if (!builder || !builder.phoneAnalyticsData) {
    return {
      id,
      offerType: 'JK',
      position: 1,
      extra,
    };
  }

  return {
    extra,
    ...pick(
      ['brand', 'nv', 'dealType', 'id', 'name', 'objectType', 'consultant', 'position'],
      builder.phoneAnalyticsData,
    ),
  };
}
